import { render, staticRenderFns } from "./Tgs.vue?vue&type=template&id=6847907d&"
import script from "./Tgs.vue?vue&type=script&lang=js&"
export * from "./Tgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports